import { environment } from '@root/environments/environment';
import { of } from 'rxjs';

interface StyleModel {
  name: string;
  value: string;
}

export function initializeStylesApp() {
  const primaryColors = environment.branding.styles.colors.primary;
  const secondaryColors = environment.branding.styles.colors.secondary;

  const primaryColorList = getThemeColor(primaryColors, 'primary');
  const secondaryColorsList = getThemeColor(secondaryColors, 'secondary');
  const themeColors = primaryColorList.concat(secondaryColorsList);

  themeColors.forEach((color: StyleModel) => {
    document.documentElement.style.setProperty(color.name, color.value);
  });
  document.documentElement.style.setProperty(
    '--neutral',
    environment.branding.styles.colors.neutral,
  );
  document.documentElement.style.setProperty(
    '--tertiary',
    environment.branding.styles.colors.tertiary,
  );
  document.documentElement.style.setProperty(
    '--crimson',
    environment.branding.styles.colors.crimson,
  );

  return of();
}

function getThemeColor(colors: Object, label: string): StyleModel[] {
  return Object.keys(colors).map(key => ({
    name: `--${label}_${key}`,
    value: (colors as any)[key],
  }));
}
